module.exports = {
          srcSet: __webpack_public_path__ + "880ba7c955819e1e767edbf48a1a5a2c-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "880ba7c955819e1e767edbf48a1a5a2c-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "880ba7c955819e1e767edbf48a1a5a2c-66.jpg",
          toString:function(){return __webpack_public_path__ + "880ba7c955819e1e767edbf48a1a5a2c-66.jpg"},
          
          width: 66,
          height: 66
        }